import SetFavicon from "./SetFavicon"
export default SetFavicon;